import { render, staticRenderFns } from "./RowInfo.vue?vue&type=template&id=2c564d72&scoped=true&"
import script from "./RowInfo.vue?vue&type=script&lang=js&"
export * from "./RowInfo.vue?vue&type=script&lang=js&"
import style0 from "./RowInfo.vue?vue&type=style&index=0&id=2c564d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c564d72",
  null
  
)

export default component.exports